import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const PrimaryButtonStyled = withStyles((theme) => ({
    contained: {
        ...theme.components.MuiButton.styleOverrides.contained,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,

        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },

        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            paddingTop: theme.components.MuiButton.styleOverrides.contained.paddingTop - 1,
        },

        '&:active, &[data-clicked=true]': {
            backgroundColor: theme.palette.primary.main,
        },
    },
}))(Button);

const PrimaryButton = ({
    children,
    onClick,
    disabled,
    disabledMessage,
    ...props
}) => {
    const [isDisabledMessageOpen, setDisabledMessageOpen] = useState(false);

    const handleClick = (event) => {
        if (disabledMessage && disabled) {
            setDisabledMessageOpen(true);
        } else {
            onClick(event);
        }
    };

    const handleDisabledMessageClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setDisabledMessageOpen(false);
    };

    return (
        <>
            <PrimaryButtonStyled
                variant="contained"
                color="primary"
                onClick={handleClick}
                aria-disabled={disabled}
                disableElevation
                disabled={disabled} // this will disable the snackbar functionality
                {...props} // eslint-disable-line react/jsx-props-no-spreading
            >
                { children }
            </PrimaryButtonStyled>

            <Snackbar
                open={isDisabledMessageOpen}
                autoHideDuration={6000}
                onClose={handleDisabledMessageClose}
                message={disabledMessage}
                action={(
                    <IconButton size="small" aria-hidden color="inherit" onClick={handleDisabledMessageClose}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                )}
            />
        </>
    );
};

PrimaryButton.defaultProps = {
    children: null,
    disabled: false,
    onClick: null,
    disabledMessage: null,
};

PrimaryButton.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    disabledMessage: PropTypes.string,
};

export default PrimaryButton;
